<template>
  <transition name="toast-animation">
    <div
      class="toast"
      v-if="value">
      <div :class="['toast-wrapper', bgClass]">
        <p>{{ msg }}</p>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  data () {
    return {
      value: false,
      msg: '',
      type: 1
    }
  },
  computed: {
    bgClass () {
      let toastBg = 'toast-blue'
      switch (this.type) {
        case 0:
          toastBg = 'toast-blue'
          break
        case 1:
          toastBg = 'toast-gray'
          break
        case 2:
          toastBg = 'toast-red'
          break
      }
      return toastBg
    }
  }
}
</script>
<style lang="scss" scoped>
.toast-animation-enter-active,
.toast-animation-leave-active {
  transition: opacity 0.5s;
}
.toast-animation-enter,
.toast-animation-leave-to {
  opacity: 0;
}
.toast {
  position: fixed;
  top: 54px;
  left: 50%;
  display: flex;
  justify-content: center;
  width: 100%;
  transform: translateX(-50%);
  .toast-wrapper {
    display: inline-block;
    padding: 7px 20px;
    border-radius: 17.5px;
    background: $color-success;
    box-shadow: 0 1px 5px 0 rgba(76, 76, 76, 0.3);
    p {
      min-width: 110px;
      max-width: 305px;
      color: $color-bg-white;
      font-size: $small-font-size;
      line-height: 18px;
      text-align: center;
      @include font-Medium;
    }
  }
  .toast-blue {
    background: $color-success;
  }
  .toast-gray {
    background: $color-status-system-error;
  }
  .toast-red {
    background: $color-status-user-error;
  }
}
</style>
